import { fetchStaffingLevels, storeStaffingLevels } from '@/service/shift/staffingLevels';
import { fetchSettings } from '@/service/shift/settings';
const { cloneDeep } = require('lodash');

function settingStaffingLevelCtrl($scope) {
  const getDate = async () => {
    const data = await fetchSettings();
    $scope.facility = data.facility;
    // 幼稚園の場合は2歳児以上の配置数を35人に緩和する
    console.log(`data.facility.facilityCategory: ${data.facility.facilityCategory}`);
    if (data.facility.facilityCategory === 5) {
      $scope.maxCapableCount = [3, 6, 35, 35, 35, 35];
    } else {
      $scope.maxCapableCount = [3, 6, 6, 20, 30, 30];
    }
  };
  getDate();

  /**
   * 編集モードの切り替え
   */
  const turnOnSettingEditMode = () => {
    $scope.isFullEditMode = true;
  };
  const turnOffSettingEditMode = () => {
    $scope.isFullEditMode = false;
  };

  $scope.staffingLevelByAgeType = 'combine';
  $scope.isStaffingLevelCombineType = true;

  $scope.$watch('staffingLevelByAgeType', () => {
    $scope.isStaffingLevelCombineType = $scope.staffingLevelByAgeType === 'combine';
    $scope.staffingLevelsIsCombineStyle = {
      visibility: $scope.isStaffingLevelCombineType ? 'hidden' : 'visible',
    };

    $scope.staffingLevelsIsCombineListClass = $scope.isStaffingLevelCombineType
      ? 'staffingLevelsListByAge_bottomBorderHide'
      : '';
  });

  $scope.$watch('staffingLevelDetailsOneYearOld.capableCount', () => {
    if ($scope.isStaffingLevelCombineType) {
      $scope.staffingLevelDetailsTwoYearOld.capableCount = $scope.staffingLevelDetailsOneYearOld.capableCount;
    }
  });

  $scope.$watch('staffingLevelDetailsFourYearOld.capableCount', () => {
    if ($scope.isStaffingLevelCombineType) {
      $scope.staffingLevelDetailsFiveYearOld.capableCount = $scope.staffingLevelDetailsFourYearOld.capableCount;
    }
  });

  $scope.staffingLevelsIsCombineStyle = {
    visibility: $scope.isStaffingLevelCombineType ? 'hidden' : 'visible',
  };

  $scope.staffingLevelsIsCombineListClass = $scope.isStaffingLevelCombineType
    ? 'staffingLevelsListByAge_bottomBorderHide'
    : '';

  $scope.staffingLevelDetailsZeroYearOld = {
    capableCount: 3,
    additionalStaffingLevel: 0,
    grade: 0,
  };

  $scope.staffingLevelDetailsOneYearOld = {
    capableCount: 6,
    additionalStaffingLevel: 0,
    grade: 1,
  };

  $scope.staffingLevelDetailsTwoYearOld = {
    capableCount: 6,
    additionalStaffingLevel: 0,
    grade: 2,
  };

  $scope.staffingLevelDetailsThreeYearOld = {
    capableCount: 20,
    additionalStaffingLevel: 0,
    grade: 3,
  };

  $scope.staffingLevelDetailsFourYearOld = {
    capableCount: 30,
    additionalStaffingLevel: 0,
    grade: 4,
  };

  $scope.staffingLevelDetailsFiveYearOld = {
    capableCount: 30,
    additionalStaffingLevel: 0,
    grade: 5,
  };

  /**
   * コピーデータを作成
   */
  const setClonedStaffingLevel = () => {
    $scope.clonedStaffingLevels = cloneDeep($scope.staffingLevels);

    const details = $scope.staffingLevels.details;
    const zeroYearOld = details[0];
    const oneYearOld = details[1];
    const twoYearOld = details[2];
    const threeYearOld = details[3];
    const fourYearOld = details[4];
    const fiveYearOld = details[5];

    $scope.staffingLevelDetailsZeroYearOld = {
      capableCount: zeroYearOld.capableCount,
      additionalStaffingLevel: zeroYearOld.additionalStaffingLevel,
      grade: zeroYearOld.grade,
    };

    $scope.staffingLevelDetailsOneYearOld = {
      capableCount: oneYearOld.capableCount,
      additionalStaffingLevel: oneYearOld.additionalStaffingLevel,
      grade: oneYearOld.grade,
    };

    $scope.staffingLevelDetailsTwoYearOld = {
      capableCount: twoYearOld.capableCount,
      additionalStaffingLevel: twoYearOld.additionalStaffingLevel,
      grade: twoYearOld.grade,
    };

    $scope.staffingLevelDetailsThreeYearOld = {
      capableCount: threeYearOld.capableCount,
      additionalStaffingLevel: threeYearOld.additionalStaffingLevel,
      grade: threeYearOld.grade,
    };

    $scope.staffingLevelDetailsFourYearOld = {
      capableCount: fourYearOld.capableCount,
      additionalStaffingLevel: fourYearOld.additionalStaffingLevel,
      grade: fourYearOld.grade,
    };

    $scope.staffingLevelDetailsFiveYearOld = {
      capableCount: fiveYearOld.capableCount,
      additionalStaffingLevel: fiveYearOld.additionalStaffingLevel,
      grade: fiveYearOld.grade,
    };

    $scope.clonedStaffingLevelByAgeType = cloneDeep($scope.staffingLevelByAgeType);
  };

  const setStaffingLevelByAgeType = (combineType) => {
    $scope.staffingLevelByAgeType = combineType ? 'combine' : 'notCombine';
    $scope.$digest();
  };

  $scope.onChangeStaffingLevelByAgeCombine = () => {
    $scope.$digest();
  };

  $scope.onChangeStaffingLevelByAgeNotCombine = () => {
    //   1歳児基準で1,2歳児の保育士一人当たりの園児数を同じにする
    $scope.staffingLevelDetailsTwoYearOld.capableCount = $scope.staffingLevelDetailsOneYearOld.capableCount;
    //  4歳児基準で4,5歳児の保育士一人当たりの園児数を同じにする
    $scope.staffingLevelDetailsFiveYearOld.capableCount = $scope.staffingLevelDetailsFourYearOld.capableCount;
    $scope.$digest();
  };

  /**
   * コピーデータをリセット
   */
  const clearClonedStaffingLevel = () => {
    $scope.clonedStaffingLevels = [];
  };

  const getTargetGradeStaffingLevelDetails = (staffingLevels, grade) => {
    return staffingLevels.details.find((staffingLevelDetails) => staffingLevelDetails.grade === grade);
  };

  const setStaffingLevelPerGrade = (staffingLevels) => {
    const zero = getTargetGradeStaffingLevelDetails(staffingLevels, 0);
    const one = getTargetGradeStaffingLevelDetails(staffingLevels, 1);
    const two = getTargetGradeStaffingLevelDetails(staffingLevels, 2);
    const three = getTargetGradeStaffingLevelDetails(staffingLevels, 3);
    const four = getTargetGradeStaffingLevelDetails(staffingLevels, 4);
    const five = getTargetGradeStaffingLevelDetails(staffingLevels, 5);
    if (zero) $scope.staffingLevelDetailsZeroYearOld = zero;
    if (one) $scope.staffingLevelDetailsOneYearOld = one;
    if (two) $scope.staffingLevelDetailsTwoYearOld = two;
    if (three) $scope.staffingLevelDetailsThreeYearOld = three;
    if (four) $scope.staffingLevelDetailsFourYearOld = four;
    if (five) $scope.staffingLevelDetailsFiveYearOld = five;
  };

  const initial = async () => {
    // 自身の設定を取得
    const authUser = await $scope.getMine();
    if (!authUser) throw new Error('getMine Error');

    const response = await fetchStaffingLevels();
    setStaffingLevelPerGrade(response);

    $scope.staffingLevels = response;

    setStaffingLevelByAgeType(response.combineFirstSecondGrade && response.combineFourthFifthGrade);

    $scope.$digest();
  };
  initial();

  $scope.showStaffingLevelCombineText = (grade) => {
    if (!$scope.isStaffingLevelCombineType) return grade;
    if (grade === 1) {
      return '1・2';
    } else if (grade === 4) {
      return '4・5';
    }
    return grade;
  };

  const formatStaffingLevelsRequest = (staffingLevels, staffingLevelByAgeType) => {
    const { version, minStaffingLevel, additionalStaffingLevel } = staffingLevels;
    const details = [
      $scope.staffingLevelDetailsZeroYearOld,
      $scope.staffingLevelDetailsOneYearOld,
      $scope.staffingLevelDetailsTwoYearOld,
      $scope.staffingLevelDetailsThreeYearOld,
      $scope.staffingLevelDetailsFourYearOld,
      $scope.staffingLevelDetailsFiveYearOld,
    ].map((staffingLevelDetails) => {
      const { additionalStaffingLevel, capableCount, grade } = staffingLevelDetails;
      const castedStaffingLevelDetails = {
        additionalStaffingLevel: Number(additionalStaffingLevel),
        capableCount: Number(capableCount),
        grade: Number(grade),
      };
      return castedStaffingLevelDetails;
    });

    let combineFirstSecondGrade = false;
    let combineFourthFifthGrade = false;

    if (staffingLevelByAgeType === 'combine') {
      combineFirstSecondGrade = true;
      combineFourthFifthGrade = true;
    }

    return {
      additionalStaffingLevel: Number(additionalStaffingLevel),
      combineFirstSecondGrade,
      combineFourthFifthGrade,
      details,
      minStaffingLevel,
      version,
    };
  };

  /**
   * 保存
   */
  $scope.onClickSaveStaffingLevels = async () => {
    const payload = formatStaffingLevelsRequest($scope.staffingLevels, $scope.staffingLevelByAgeType);
    $scope.staffingLevels = await storeStaffingLevels(payload);
    turnOffSettingEditMode();
    $scope.$digest();
  };

  /**
   * 編集
   */
  $scope.onClickEditStaffingLevels = () => {
    setClonedStaffingLevel();
    turnOnSettingEditMode();
  };

  $scope.integerPattern = {
    regex: /^([1-9][0-9]*|0)$/i,
    message: '整数を入力してください',
  };

  /**
   * キャンセル
   */
  $scope.onClickCancelStaffingLevels = () => {
    $scope.staffingLevels = $scope.clonedStaffingLevels;
    $scope.staffingLevelByAgeType = $scope.clonedStaffingLevelByAgeType;
    clearClonedStaffingLevel();
    turnOffSettingEditMode();
  };
}

angular.module('inspinia').controller('settingStaffingLevelCtrl', settingStaffingLevelCtrl);
